import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { AUTO_HERO, MOTO_HERO } from "../mock/data";
import useReveal from "../hooks/useReveal";

function ExploreCard({ to, image, kicker, title, desc, i }) {
  const { ref, inView } = useReveal();
  return (
    <Link
      ref={ref}
      to={to}
      style={{ animationDelay: `${i * 0.12}s` }}
      className={`reveal ${inView ? "in-view" : ""} group relative block overflow-hidden h-[460px] border border-white/10 hover:border-baja-red transition-colors duration-300`}
    >
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1000ms]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/10" />
      <div className="absolute bottom-0 left-0 p-8 w-full">
        <span className="font-cond uppercase tracking-[0.25em] text-sm baja-red">{kicker}</span>
        <h3 className="font-display text-4xl md:text-5xl uppercase text-white mt-1">{title}</h3>
        <p className="mt-3 text-white/65 max-w-md">{desc}</p>
        <span className="mt-5 inline-flex items-center gap-2 font-cond uppercase tracking-wider text-white group-hover:text-baja-red transition-colors">
          Explore Range <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
        </span>
      </div>
    </Link>
  );
}

export default function ExploreSection() {
  return (
    <section className="bg-[#0a0a0a] py-24">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-baja-red" />
            <span className="font-cond uppercase tracking-[0.25em] text-sm baja-red">Two Worlds. One Standard.</span>
            <span className="h-[2px] w-10 bg-baja-red" />
          </div>
          <h2 className="font-display text-4xl md:text-6xl uppercase text-white">CHOOSE YOUR TERRAIN</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          <ExploreCard
            to="/automotive"
            image={AUTO_HERO}
            kicker="Automotive"
            title="4x4 & OFF-ROAD"
            desc="Light bars, pods and vehicle-specific kits for trucks, Jeeps, UTVs and overlanders."
            i={0}
          />
          <ExploreCard
            to="/motorcycle"
            image={MOTO_HERO}
            kicker="Motorcycle"
            title="ADV & DUAL-SPORT"
            desc="Auxiliary lights, compact pods and headlight kits built for the long, dark ride."
            i={1}
          />
        </div>
      </div>
    </section>
  );
}
